import React from 'react';

export default class BuilderCompanyPage extends React.Component {
    render() {
        return (<div>
            <div>ChangePassword</div>
            <div>manage users</div>
            <div>manage articles</div>
            <div>manage menu</div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./assets/src/js/components/pages/BuilderCompanyPage.jsx